import { Component, Injectable, OnInit, Input } from '@angular/core';
import { CommonService } from '../service/common.service';
import { ShareService } from '../service/share.service';
import { AdminshareService } from "../service/adminshare.service";
import { YoyakuService } from '../service/yoyaku.service';
import { ActivatedRoute, Router, RouterEvent, NavigationEnd } from '@angular/router';
import { Location } from '@angular/common';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { AViewTextModalComponent } from '../a0106-mail/a-view-text-modal.component';
import { UsersService } from '../service/users.service';
import { Role } from '../app.constant';
import { NgbInputDatepicker,NgbDatepickerI18n,NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';

import { YoyakuListAddComponent } from "../g3801-yoyaku-list-add/yoyaku-list-add.component";
const I18N_VALUES = {
    'ja': {
        weekdays: ['月', '火', '水', '木', '金', '土', '日'],
        months: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
      }
    };
     
  @Injectable()
  export class I18n {
      language = 'ja';
  }
  @Injectable()
  export class CustomDatepickerI18n extends NgbDatepickerI18n {
    constructor(private _i18n: I18n) {
      super();
    }
    getWeekdayShortName(weekday: number): string {
      return I18N_VALUES[this._i18n.language].weekdays[weekday - 1];
    }
    getMonthShortName(month: number): string {
      return I18N_VALUES[this._i18n.language].months[month - 1];
    }
    getMonthFullName(month: number): string {
      return this.getMonthShortName(month);
    }
  }
@Component({
    selector: 'yoyaku-hyo-app',
    templateUrl: './yoyaku-hyo.component.html',
    styleUrls: ['yoyaku-hyo.component.css']
})
export class YoyakuHyoComponent implements OnInit {
    @Input() event_id: number;
    title: string = '予約表一覧';

    page : number = 1;
    all_count:number=0;
    display_per_page:  number = 20;   /* 最大表示件数 */

    isLoaded: boolean = false;
    selected: boolean = false;
    datalist: any = [];
    all_datalist: any = [];
    selectedList: any = [];
    yoaykuhyoList: any =[];
    company:any =[];
    
    event: any = [];
    selectmode: boolean = true;
    selected_event_id: number = null;
    tempSelectedRow: any;
    ROLE: any = Role;
    content_list_info: any = {
        'name_name': 'タイトル',
        'name_description': '説明文',
        'name_support': 'タイトルを入力してください',
        'description_support': '説明文を入力してください',
        'data': {},
        'languagelist': [],
        'timeaxsislist': [],
    };
    private previousUrl: string = undefined;
    private currentUrl: string = undefined;

    constructor(
        private commonService: CommonService,
        private shareService: ShareService,
        private adminShareService: AdminshareService,
        private yoyakuService: YoyakuService,
        public usersService: UsersService,
        private modalService: NgbModal,
        private router: Router,
        private route: ActivatedRoute,
        private location: Location,
    ) {}

    ngOnInit(): void {
        this.selected_event_id = +this.route.snapshot.paramMap.get('eid');
        this.getList();
        if (this.selected_event_id == 0) {
            this.selectmode = true;
        } else {
            this.selectmode = false;
        }
        if (this.selected_event_id == this.adminShareService.set_question_category.event_id && this.selected_event_id != 0) {
            this.selectedList = this.adminShareService.set_question_category.temp_selected_list;
        } else {
            this.adminShareService.set_question_category={
                event_id:this.selected_event_id,
                temp_selected_list:this.selectedList
            };
        }

        //画面上部へ移動
        window.scrollTo(0, 0);
    };

    clearData(): void {
        this.isLoaded = false;
        this.editSelectRowData(undefined);
        this.selected = false;
        this.event = [];
        this.datalist = [];
    }

    getList(): void {
        this.clearData();
        let param ={
            eid:this.selected_event_id,
            page:this.page,
            display_per_page:this.display_per_page
        };
        this.yoyakuService.getYoyakuhyoAdmin(param)
            .subscribe((res: Response) => {
                if (res["fuel_status"] == "OK") {
                    this.event = res["fuel_results"]['event'];
                    if (this.selected_event_id != 0 && this.event.length == 0) {
                        //消されたメッセージを表示し、イベント一覧画面へ飛ばす
                        this.commonService.modalOpens(11006, modalresult => {
                            this.router.navigate(["/event"]);
                        });
                    }
                    this.content_list_info.languagelist = res["fuel_results"]['language'];
                    this.company = res["fuel_results"]['company_result'][0];
                    var selwork = res["fuel_results"]["selected"];

                    for (let i = 0; i < selwork.length; i++) {
                        selwork[i]['selected'] = this.commonService.exchange01toTF(selwork[i]['selected']);
                        this.selectP(selwork[i]);
                    }  

                    this.all_count = res["fuel_results"]["all_count"];
                    this.all_datalist = res["fuel_results"]["yoyakuhyo_info"];
                    for (let i = 0; i < this.all_datalist.length; i++) {
                        this.all_datalist[i]['db_selected'] = this.commonService.exchange01toTF(this.all_datalist[i]['selected']);
                        this.all_datalist[i]['disabled'] = this.commonService.exchange01toTF(this.all_datalist[i]['disabled']);
                    }
                    this.changePage(1);

                    this.isLoaded = true;

                }else if (res["fuel_status"] == "NG") {
                    this.commonService.modalOpens(res["fuel_message"],modalresult=>{});
                }else{
                    this.commonService.modalOpens(11003,modalresult=>{});
                }
            }, error => {
                this.commonService.modalOpens(error,modalresult=>{});
            });
    }

    save(): void {
        this.commonService.modalOpens(50001,
            //保存してもよろしいですか？
            modalresult => {
                if (modalresult == "OK") {
                    this.content_list_info.data.multiple_flg = this.commonService.exchangeTFto01(this.content_list_info.data.multiple_flg);
                    this.content_list_info.data.online_flg = this.commonService.exchangeTFto01(this.content_list_info.data.online_flg);
                    this.yoyakuService.saveYoyakuhyo(this.content_list_info.data)
                        .subscribe((res: Response) => {
                            if (res["fuel_status"] == "OK") {
                                this.commonService.modalOpens(10001, modalresult => { });
                                this.editSelectRowData(undefined);
                                this.selected = false;
                                this.page = 1;
                                this.getList();
                            }else if (res["fuel_status"] == "NG") {
                                this.commonService.modalOpens(res["fuel_message"],modalresult=>{});
                            }else{
                                this.commonService.modalOpens(11003,modalresult=>{});
                            }
                        }, error => {
                            this.commonService.modalOpens(error,modalresult=>{});
                        });
                    } else {
                    //
                }
            }
        );
    }
    cancel(): void {
        this.commonService.modalOpens(50005,
            //編集中の内容を破棄してもよろしいですか？
            modalresult => {
                if (modalresult == "OK") {
                    this.editSelectRowData(undefined);
                    this.selected = false;
                } else {

                }
            }
        );
    }
    delete(): void {
        this.commonService.modalOpens(50002,
            //削除してもよろしいですか？
            modalresult => {
                if (modalresult == "OK") {
                    this.yoyakuService.deleteYoyaku(this.content_list_info.data)
                        .subscribe((res: Response) => {
                            if (res["fuel_status"] == "OK") {
                                this.commonService.modalOpens(10002, modalresult => {
                                    this.selectedList = this.selectedList.filter(
                                        item =>
                                            item.m_yoyakuhyo_id != this.content_list_info.data.m_yoyakuhyo_id
                                    );
                                    this.editSelectRowData(undefined);
                                    this.selected = false;
                                    this.page = 1;
                                    this.getList();
                                });
                            }else if (res["fuel_status"] == "NG") {
                                this.commonService.modalOpens(res["fuel_message"],modalresult=>{});
                            }else{
                                this.commonService.modalOpens(11003,modalresult=>{});
                            }
                        }, error => {
                            this.commonService.modalOpens(error,modalresult=>{});
                        });
                    } else {

                }
            }
        );
    }

    // 編集
    edit(row: any): void {
        if (this.selected) {
            this.commonService.modalOpens(50005,
                //編集中の内容を破棄してもよろしいですか？
                modalresult => {
                    if (modalresult == "OK") {
                        this.editSelectRowData(row);
                        //画面上部へ移動
                        window.scrollTo(0, 0);

                    } else {
                        return;
                    }
                }
            );
        } else {
            this.editSelectRowData(row);
            //画面上部へ移動
            window.scrollTo(0, 0);
        }
    }

    editSelectRowData(row: any): void {
        if (row == undefined) {
            this.selected = true;
            this.content_list_info.data = {
                m_yoyakuhyo_id: null,
                m_contract_company_id: null,
                update_datetime: null,
                congestion_ratio: null,
                yoyaku_limit_days: null,
                yoyaku_memo: null,
                multiple_flg: false,
                online_flg: false,
                start_date:null,
                sort:false,
                sum_count:null,
                public_date_start:null,
                public_date_end:null,
                content: [
                    {
                        m_language_id: null,
                        title_name: null,
                        description: "",
                    }
                ],
            };

        } else {
            this.selected = true;
            this.content_list_info.data = JSON.parse(JSON.stringify(row));
            this.tempSelectedRow = JSON.parse(JSON.stringify(row));
            this.content_list_info.data.multiple_flg = this.commonService.exchange01toTF(this.content_list_info.data.multiple_flg);
            this.content_list_info.data.online_flg = this.commonService.exchange01toTF(this.content_list_info.data.online_flg);

            if(this.content_list_info.data.public_date_start!=null){
                this.content_list_info.data.public_date_start = this.commonService.exchangeDateFormat1(this.content_list_info.data.public_date_start);
            }
            if(this.content_list_info.data.public_date_start!=null){
                this.content_list_info.data.public_date_end = this.commonService.exchangeDateFormat1(this.content_list_info.data.public_date_end);
            }
            // if (row.question_count > 0) {
            //     this.content_list_info.data.list_edit_flg = false;
            // } else {
            //     this.content_list_info.data.list_edit_flg = true;
            // }
        }
    }

    changePage(e){
        var start = (e-1)*this.display_per_page;
        this.datalist = this.all_datalist.slice(start, start+this.display_per_page);
        for (let i = 0; i < this.datalist.length; i++) {
            if (this.checkSelectedList(this.datalist[i]['m_yoyakuhyo_id'])){
                this.datalist[i]['selected'] = true;
            } else{
                this.datalist[i]['selected'] = false;
            }
        }
    }
    selectP(row){
        if (row.selected){
            if (this.checkSelectedList(row['m_yoyakuhyo_id'])){
            }else{
                this.selectedList.push(row)
            }
        }
        else{
            this.selectedList = this.selectedList.filter(
                item =>
                    item.m_yoyakuhyo_id != row.m_yoyakuhyo_id
            );
        }
    }
    //selectedListにm_yoyakuhyo_idが含まれているか
    checkSelectedList(id:string):boolean{
        var row = this.selectedList.filter(
            item =>
                item.m_yoyakuhyo_id === id
        );
        if (row.length>0){
            return true
        }else{
            return false
        }
    }
    selectedlistOpen() : void {
        const modalRef = this.modalService.open(
            AViewTextModalComponent,//対象のComponent
            { backdrop: 'static', keyboard: false,size: 'lg' }//オプション設定　Esc,背景クリックの時の処理…停止中
        );

        let sendlisttext :string = "";

        modalRef.componentInstance.view_title = '選択リスト';
        sendlisttext = "全"+this.selectedList.length + "件<br>";
        for (let i = 0; i < this.selectedList.length; i++) {
            for (let j = 0; j < this.selectedList[i].content.length; j++) {
                if (j==0){
                    sendlisttext += "<hr>・"+this.selectedList[i].content[j]['language_letter']+"："+this.selectedList[i].content[j]['title_name']+"<br>";
                }else{
                    sendlisttext += "　"+this.selectedList[i].content[j]['language_letter']+"："+this.selectedList[i].content[j]['title_name']+"<br>";
                }
            }
        }

        modalRef.componentInstance.view_text = sendlisttext;
        modalRef.result.then(
            result => {
                if(result.status=='Cancel'){
                    //Cancel時の処理
                }else{
                    
                }
            }, function () {
            // Esc,背景クリックの時の処理…オプション設定で停止中
            }
        );
    }



    checkList(): boolean {
        var tempList = this.content_list_info.data;
        var row = tempList.content.filter(
            item =>
                item.m_language_id == null 
                || item.title_name == null 
                || item.title_name == "" 
                || item.title_name.length > 128 
                || (item.description !=null? item.description.length> 1000 : item.description ==null)
        );
        if (row.length > 0) {
            return true;
        }
        if (this.content_list_info.data.yoyaku_limit_days == null
            || this.content_list_info.data.yoyaku_limit_days == "" 
            || this.content_list_info.data.yoyaku_limit_days.length >2) {
            return true;
        }
        if (this.content_list_info.data.congestion_ratio == null
            || this.content_list_info.data.congestion_ratio == "" 
            || this.content_list_info.data.congestion_ratio.length >2) {
            return true;
        }
        
        //言語数以上登録されていないか
        if (this.content_list_info.languagelist.length < tempList.content.length) {
            return true;
        }

        //予約表示機関の大小チェック
        if(this.checkDate()){
            return true;
        }
        
        return false;
    }
    setYoyaku(row: any): void {
        if(this.selected){
            this.commonService.modalOpens(50005,
            //編集中の内容を破棄してもよろしいですか？
            modalresult => {
                    if (modalresult == "OK"){
                        this.adminShareService.set_question_category={
                            event_id:this.selected_event_id,
                            temp_selected_list:this.selectedList
                        };
                        this.router.navigate(["/yoyaku-register/" + row.m_yoyakuhyo_id]);
                    }else{
                        return;
                    }
                }
            );
        }else{
            this.adminShareService.set_question_category={
                event_id:this.selected_event_id,
                temp_selected_list:this.selectedList
            };
            this.router.navigate(["/yoyaku-register/" + row.m_yoyakuhyo_id]);
        }

    }
    confYoyaku(row: any): void {
        if(this.selected){
            this.commonService.modalOpens(50005,
            //編集中の内容を破棄してもよろしいですか？
            modalresult => {
                    if (modalresult == "OK"){
                        this.adminShareService.set_question_category={
                            event_id:this.selected_event_id,
                            temp_selected_list:this.selectedList
                        };
                        this.router.navigate(["/yoyaku-list/" + row.m_yoyakuhyo_id]);
                    }else{
                        return;
                    }
                }
            );
        }else{
            this.adminShareService.set_question_category={
                event_id:this.selected_event_id,
                temp_selected_list:this.selectedList
            };
            this.router.navigate(["/yoyaku-list/" + row.m_yoyakuhyo_id]);
        }

    }
    selectedRow(): any {
        return this.datalist.filter(
            item =>
                item.selected
        );
    }

    // 設定する
    set(): void {
        let selRows = this.selectedList;
        if (selRows.length == 0) {
            this.commonService.modalOpens(50006,
                //選択されていませんが、保存してよろしいですか？
                modalresult => {
                    if (modalresult == "OK") {
                        this.setCategory(this.selectedList);
                    } else {
                        return false;
                    }
                }
            );
        } else {
            this.commonService.modalOpens(50001,
                //保存してよろしいですか？
                modalresult => {
                    if (modalresult == "OK") {
                        this.setCategory(selRows);
                    } else {
                        return false;
                    }
                }
            );
        }

    }

    setCategory(selRows): void {
        let param = {
            event_id: this.selected_event_id,
            datalist: selRows,
        };
        this.yoyakuService.setYoyaku(param)
            .subscribe((res: Response) => {
                if (res["fuel_status"] == "OK") {
                    this.commonService.modalOpens(10004, modalresult => {
                        this.router.navigate(["/event"]);
                    });
                }else if (res["fuel_status"] == "NG") {
                    this.commonService.modalOpens(res["fuel_message"],modalresult=>{});
                }else{
                    this.commonService.modalOpens(11003,modalresult=>{});
                }
            }, error => {
                this.commonService.modalOpens(error,modalresult=>{});
            });
        }

    setcancel(row: any): void {
        this.commonService.modalOpens(50007,
            //保存されていませんが、キャンセルしてよろしいですか？
            modalresult => {
                if (modalresult == "OK") {
                    this.router.navigate(["/event"]);
                } else {
                    //
                }
            }
        );
    }

    goBack(): void {
        if(this.selected){
            this.commonService.modalOpens(50005,
            //編集中の内容を破棄してもよろしいですか？
            modalresult => {
                    if (modalresult == "OK"){
                            this.location.back();
                    }
                }
            );
        }else{
                this.location.back();
        }
    }

    goManintenance(): void {
        if(this.selected){
            this.commonService.modalOpens(50005,
            //編集中の内容を破棄してもよろしいですか？
            modalresult => {
                    if (modalresult == "OK"){
                        this.router.navigate(["/yoyaku-maintenance"]);
                    }
                }
            );
        }else{
            this.router.navigate(["/yoyaku-maintenance"]);
        }
    }
    // ★関学聖和対応
    goAddQuestion(id:any): void {
        const modalRef = this.modalService.open(
          YoyakuListAddComponent, //対象のComponent
          { backdrop: "static", keyboard: false, size: "lg" } //オプション設定　Esc,背景クリックの時の処理…停止中
        );
            modalRef.componentInstance.selectedId = id;
            modalRef.result.then(
            (result) => {
                if (result.status == "OK") {
                    //
                } else {
                //
                }
            },
            function () {
                // Esc,背景クリックの時の処理…オプション設定で停止中
            }
            );
    }
    dateClear(mode:number): void{
        if(mode==1){
            this.content_list_info.data.public_date_start = null;
        }else{
            this.content_list_info.data.public_date_end = null;
        }
    }   
    checkDate():boolean{
        if( this.content_list_info.data.public_date_start == null || this.content_list_info.data.public_date_end == null){
            return false;
        } else {
            if( this.commonService.exchangeDateFormat2(this.content_list_info.data.public_date_start) > this.commonService.exchangeDateFormat2(this.content_list_info.data.public_date_end)){
                return true;
            } else {
                return false;
            }
        }
    }
    /**
     * 切り替えるDatePicker以外を閉じながら、
     * toggleで表示非表示を切り替える
     * 
     * @param selectDp 切り替えるDatePicker
     * @param subDp1 閉じるDatePicker1
     * @param subDp2 閉じるDatePicker2
     * @param subDp3 閉じるDatePicker3
     */
    toggleDate(selectDp: NgbInputDatepicker, subDp1: NgbInputDatepicker): void{
        selectDp.toggle();
        subDp1.close();
    }
}


// WEBPACK FOOTER //
// ./src/app/a2102-yoyaku-hyo/yoyaku-hyo.component.ts